import { useState } from 'react';
import SuccessModel from '../SuccessModel';
import { useSelector } from 'react-redux';

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

const Error500: React.FC<ModalProps> = ({ isOpen, closeModal }) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries, assets } = contentfulData;

  return (
    <SuccessModel
      isOpen={isOpen}
      title={entries?.rb_error?.genericApiFailure?.header}
      subTitle={entries?.rb_error?.genericApiFailure?.text}
      successIcon={false}
      closeModal={closeModal}
      errorIcon={false}
    />
  );
};
export default Error500;
